// components
import MNPG from "./MNPG";
// types
import { TMainPageLayoutV3 } from "../type";


const MNPG018 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG018.rendered: ", props);

    if ( !props.template ) return null;

    return (
        <section className="section-padding-2 fix">
            <div className="container d-flex flex-column gap-3">
                <MNPG templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} params={props.params} />
            </div>
        </section>
    )
}

export default MNPG018;
